import { ReactNode } from 'react';

import ImageWithFallback from 'components/ImageWithFallback';
import styles from './imageWithText.module.css';

const ImageWithText = ({
  imageSrc,
  imageAlt,
  imageOverlayChildren,
  desktopSize,
  title,
  textChildren,
}: {
  imageSrc: string;
  imageAlt?: string;
  imageOverlayChildren?: ReactNode;
  desktopSize?: 'full' | 'half' | 'third';
  title?: string;
  textChildren?: ReactNode;
}) => {
  return (
    <div
      className={
        styles.imageWithText + ` ${styles['imageWithText__' + desktopSize]}`
      }
    >
      <div className={styles.image}>
        <ImageWithFallback
          src={imageSrc}
          layout="fill"
          className={styles.thumbnailImage}
          alt={imageAlt ? imageAlt : 'Image'}
        />
        {imageOverlayChildren && (
          <div className={styles.imageOverlay}>{imageOverlayChildren}</div>
        )}
      </div>
      <div className={styles.textSection}>
        {title && <div className={styles.title}>{title}</div>}
        {textChildren && textChildren}
      </div>
    </div>
  );
};

export default ImageWithText;
